import i18n from "../translations/i18n";
import {LanguagesType} from "../constants/constants";

export const getSupportedLangFromCompany = (supportedLangArr: string[], currentI18nLang: string) => {
  const rmCountryCode = currentI18nLang.split('-')[0]
  const langs = (supportedLangArr && supportedLangArr.length > 0) ? supportedLangArr : ['en', 'da', 'sv']
  return langs.includes(rmCountryCode) ?
    rmCountryCode : supportedLangArr.includes(LanguagesType.English) ?
      LanguagesType.English : supportedLangArr[0]
}

export const getTextByCurrentLanguage = (object: {[key: string]: string} | undefined | string) => {
  const { language } = i18n
  if (typeof object === 'string') {
    return object
  }
  let text = object ? object['en'] : ''
  if (object && object[language]) {
    text = object[language]
  }
  return text
}
